import React from "react";

const MypartiallClosedDeal = () => {
  return <div>MypartiallClosedDeal</div>;
};

export default MypartiallClosedDeal;
